module.exports = __webpack_public_path__ + "img/antecedents.d7d676f3.svg";